import React from 'react';
import { Image } from 'components/ui';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import StarRating from 'components/StarRating/StarRating';
import ReviewCount from 'components/Product/ReviewCount';
import FrameworkUtils from 'utils/framework';
import {
    colors, space, fontSizes, mediaQueries, lineHeights
} from 'style/config';

const { wrapFunctionalComponent } = FrameworkUtils;

const styles = {
    result: {
        display: 'flex',
        alignItems: 'center',
        minWidth: '100%',
        paddingTop: space[2],
        paddingBottom: space[2],
        lineHeight: lineHeights.tight,
        [mediaQueries.xsMax]: {
            marginLeft: -space.container,
            marginRight: -space.container,
            paddingLeft: space.container,
            paddingRight: space.container
        },
        [mediaQueries.sm]: {
            paddingLeft: space[4],
            paddingRight: space[4]
        }
    },
    resultHover: {
        backgroundColor: colors.nearWhite
    },
    resultHeader: {
        color: colors.gray
    },
    resultFocusVisible: {
        outline: '2px solid',
        outlineColor: colors.black,
        outlineOffset: '-2px'
    },
    contentWrap: {
        flex: 1,
        minWidth: 0
    },
    ratingWrap: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
        marginTop: space[1],
        fontSize: fontSizes.xs
    },
    ratingValue: {
        marginRight: '.375em',
        fontWeight: 'var(--font-weight-bold)'
    },
    reviewCount: {
        marginLeft: '.375em'
    }
};

function SearchItem({
    index = -1,
    isActive = false,
    value = '',
    productId,
    iconPath = '',
    defaultSku,
    sectionTitle = '',
    sectionLabel,
    result,
    idPrefix = 'site_search',
    //TODO: Replace KS with AB/Test implementation in the future
    showStarRating = false,
    onMouseEnter = () => '',
    handleItemClick = () => ''
}) {
    const isProductItem = !!defaultSku;
    const rating = Number(result?.rating) || 0;
    const reviewCount = Number(result?.totalReviews) || 0;
    const hasRating = isProductItem && showStarRating && rating > 0;

    return sectionTitle ? (
        <li
            role='presentation'
            css={[styles.result, styles.resultHeader]}
            children={sectionTitle}
        />
    ) : (
        <li
            key={productId || index}
            role='option'
            aria-selected={isActive}
            data-focus-visible={isActive ? 'true' : undefined}
            id={`${idPrefix}_result${index}`}
            css={[styles.result, isActive && styles.resultHover, isActive && styles.resultFocusVisible]}
            onMouseEnter={onMouseEnter}
            onClick={handleItemClick}
            data-cnstrc-item-section={sectionLabel}
            data-cnstrc-item-name={result?.term || result?.productName}
            data-cnstrc-item-id={productId}
        >
            {iconPath ? (
                <Image
                    src={iconPath}
                    size={16}
                    css={{
                        marginRight: space[3],
                        marginTop: '.25em'
                    }}
                />
            ) : null}
            {isProductItem && (
                <ProductImage
                    id={defaultSku.skuId}
                    marginRight={4}
                    size={32}
                />
            )}
            {isProductItem ? (
                <div css={styles.contentWrap}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: value
                        }}
                    />
                    {hasRating && (
                        <div css={styles.ratingWrap}>
                            <span css={styles.ratingValue}>{rating.toFixed(1)}</span>
                            <StarRating
                                rating={rating}
                                size={12}
                            />
                            <ReviewCount
                                css={styles.reviewCount}
                                productReviewCount={reviewCount}
                                showReviewsText={true}
                                showParentheses={true}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <span
                    css={{ flex: 1 }}
                    dangerouslySetInnerHTML={{
                        __html: value
                    }}
                />
            )}
        </li>
    );
}

export default wrapFunctionalComponent(SearchItem, 'SearchItem');
